/* ============================================
   REMUSE — Shopify Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- Header Scroll Shadow --- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* --- Product Gallery Thumbnails --- */
  const galleryMain = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      const newSrc = thumb.querySelector('img').getAttribute('data-full');
      if (galleryMain && newSrc) {
        galleryMain.src = newSrc;
      }
    });
  });

  /* --- Product Tabs --- */
  const tabButtons = document.querySelectorAll('.product-tabs__tab');
  const tabPanels = document.querySelectorAll('.product-tabs__panel');

  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const target = btn.getAttribute('data-tab');

      tabButtons.forEach(function(b) { b.classList.remove('active'); });
      tabPanels.forEach(function(p) { p.classList.remove('active'); });

      btn.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* --- Variant Selector Buttons --- */
  document.querySelectorAll('.variant-selector__options').forEach(function(group) {
    group.querySelectorAll('.variant-option').forEach(function(option) {
      option.addEventListener('click', function() {
        group.querySelectorAll('.variant-option').forEach(function(o) {
          o.classList.remove('selected');
        });
        option.classList.add('selected');

        // Update hidden input if exists
        var inputName = group.getAttribute('data-option-name');
        var hiddenInput = document.querySelector('input[name="' + inputName + '"]');
        if (hiddenInput) {
          hiddenInput.value = option.getAttribute('data-value');
        }

        // Trigger variant change
        updateVariant();
      });
    });
  });

  function updateVariant() {
    // Shopify variant update logic
    var form = document.querySelector('.product-form');
    if (!form) return;

    var selectedOptions = [];
    form.querySelectorAll('.variant-selector__options').forEach(function(group) {
      var selected = group.querySelector('.variant-option.selected');
      if (selected) {
        selectedOptions.push(selected.getAttribute('data-value'));
      }
    });

    // Find matching variant
    if (window.productVariants) {
      var match = window.productVariants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (match) {
        // Update price
        var priceEl = document.querySelector('.product-info__price');
        if (priceEl) {
          priceEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(match.price) : '$' + (match.price / 100).toFixed(2);
        }

        // Update URL
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);

        // Update add to cart button
        var addBtn = document.querySelector('.btn-add-to-cart');
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = match.id;

        if (addBtn) {
          if (match.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Bag';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold Out';
          }
        }
      }
    }
  }

  /* --- Quantity Selector --- */
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('[data-action="minus"]');
    var plus = selector.querySelector('[data-action="plus"]');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.faq-item__question').forEach(function(question) {
    question.addEventListener('click', function() {
      var item = question.closest('.faq-item');
      var isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item').forEach(function(faq) {
        faq.classList.remove('open');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });

  /* --- Collection Filter Tabs --- */
  document.querySelectorAll('.filter-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var group = tab.closest('.collection-filters__tabs');
      if (group) {
        group.querySelectorAll('.filter-tab').forEach(function(t) {
          t.classList.remove('active');
        });
      }
      tab.classList.add('active');

      var filter = tab.getAttribute('data-filter');
      var cards = document.querySelectorAll('.product-card[data-tag]');

      cards.forEach(function(card) {
        if (filter === 'all' || card.getAttribute('data-tag') === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });

      // Update count
      var visible = document.querySelectorAll('.product-card[data-tag]:not([style*="display: none"])').length;
      var countEl = document.querySelector('.collection-count');
      if (countEl) {
        countEl.textContent = visible + ' product' + (visible !== 1 ? 's' : '');
      }
    });
  });

  /* --- Smooth Scroll to Anchors --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --- Intersection Observer for Fade-In Animations --- */
  var observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  var fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-in').forEach(function(el) {
    fadeObserver.observe(el);
  });

  /* --- Add to Cart AJAX --- */
  var addToCartForms = document.querySelectorAll('.product-form');
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = form.querySelector('.btn-add-to-cart');
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);

        // Update cart count
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var countEls = document.querySelectorAll('.header__cart-count');
            countEls.forEach(function(el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          });
      })
      .catch(function(err) {
        btn.textContent = 'Error';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
    });
  });

})();
